import { render, staticRenderFns } from "./NewMessageModal.vue?vue&type=template&id=6df2fba3&scoped=true"
import script from "./NewMessageModal.vue?vue&type=script&lang=js"
export * from "./NewMessageModal.vue?vue&type=script&lang=js"
import style0 from "./NewMessageModal.vue?vue&type=style&index=0&id=6df2fba3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df2fba3",
  null
  
)

export default component.exports